import { Alert, Snackbar, Typography, Box, IconButton } from '@mui/material';
import React, { createContext, forwardRef, useEffect, useState } from 'react';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import PauseCircleIcon from '@mui/icons-material/PauseCircle';
import StopCircleIcon from '@mui/icons-material/StopCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import useDateFunc from '../../hooks/useDateFunc';

export const AudioContext = createContext();

const AudioPlayer = forwardRef(({ children }, ref) => {
    //-------------------- HOOKS ------------------
    const { t } = useTranslation();
    const { sToTime } = useDateFunc()
    const [isAudioPlaying, setIsAudioPlaying] = useState(false);
    const [audio, setAudio] = useState();
    const [currentAudio, setCurrentAudio] = useState({
        file: "",
        id: "",
        name: ""
    })
    const [time, setTime] = useState({
        currentTime: 0,
        duration: 0,
        progress: 0
    })
    //-------------- SNACKBAR ----------------
    const [snackbarState, setSnackbarState] = useState({
        open: false,
        vertical: 'top',
        horizontal: 'center',
        message: "audio6789012"
    });
    const { vertical, horizontal, open, message } = snackbarState;

    const handleSnackbarClose = () => {
        setSnackbarState(prev => ({ ...prev, open: false }));
    }
    const handleSnackbarOpen = () => {
        setSnackbarState(prev => ({ ...prev, open: true }));
    }
    //-------------- METHODS -----------------
    const onPlaying = () => {
        const duration = ref.current.duration;
        const currentTime = ref.current.currentTime;
        setTime({ currentTime, duration, progress: currentTime / duration * 100 })
        if (duration === currentTime) {
            setIsAudioPlaying(false);
            // handleSnackbarClose();
        }
    }
    const playAudio = (a, name, id) => {
        setAudio(a);
        setCurrentAudio({
            file: a,
            name: name,
            id: id
        });
        handleSnackbarOpen();
        setIsAudioPlaying(true);
    }
    const pauseAudio = () => {
        setIsAudioPlaying(false);
    }
    const stopAudio = () => {
        setIsAudioPlaying(false);
        ref.current.currentTime = 0;
    }

    const closeAudio = () => {
        setIsAudioPlaying(false);
        handleSnackbarClose();
        ref.current.currentTime = 0;
    }
    //------------ USE EFFECT --------------------
    useEffect(() => {
        if (!audio) return;
        if (isAudioPlaying) {

            ref.current.play().catch(err => {
                toast.error(t("audio_cannot_play"));
                console.log('[AudioPlayer] Hata:', err)
                closeAudio();
            })
        } else {
            ref.current.pause();
        }
    }, [isAudioPlaying, audio]);
    //------------- RETURN -----------------------
    return (
        <AudioContext.Provider value={{
            isAudioPlaying,
            currentAudio,
            onPlaying,
            playAudio,
            pauseAudio,
            stopAudio,
        }} >
            <audio ref={ref} src={audio} onTimeUpdate={onPlaying} />
            <Snackbar
                anchorOrigin={{ vertical, horizontal }}
                open={open}
            >
                <Alert icon={false} severity="info">
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
                        <Box sx={{ width: "100%", height: "6px", borderRadius: "6px", background: theme => theme.palette.background.paper, overflow: "hidden" }}>
                            <Box sx={{ width: `${time.progress}%`, height: "6px", borderRadius: "6px", background: theme => theme.palette.success.main }}>
                            </Box>
                        </Box>
                        <Box sx={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                            <Typography variant='body2'>{sToTime(time.currentTime)}</Typography>
                            <Typography variant='body2'>{sToTime(time.duration)}</Typography>
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                            {/* <Typography>{message.slice(0, 11)}{message.length > 10 && "..."}</Typography> */}
                            {
                                isAudioPlaying ?
                                    <IconButton size="large" aria-label="pause" onClick={() => pauseAudio()}>
                                        <PauseCircleIcon fontSize="inherit" />
                                    </IconButton> :
                                    <IconButton size="large" aria-label="play" onClick={() => playAudio(currentAudio.file, currentAudio.name, currentAudio.id)}>
                                        <PlayCircleIcon fontSize="inherit" />
                                    </IconButton>
                            }
                            <IconButton size="large" aria-label="stop" onClick={stopAudio}>
                                <StopCircleIcon fontSize="inherit" />
                            </IconButton>
                            <IconButton size="large" aria-label="close" onClick={closeAudio}>
                                <CancelIcon fontSize="inherit" />
                            </IconButton>
                        </Box>
                    </Box>
                </Alert>
            </Snackbar>
            {children}
        </AudioContext.Provider >
    )
}
)
export default AudioPlayer